module.exports = __webpack_public_path__ + "static/media/futsal_pitch.96f552ba.svg";